import { useContext } from 'react'
import { LayoutContext } from '../contexts'
import { useShopify } from '../contexts/shopify'
import applyCheckoutDiscountCode from '../shopify/applyCheckoutDiscountCode'
import { getSegmentAnonymousId } from '../utils'

const useApplyDiscountCode = () => {
  const { storeSubdomain } = useContext(LayoutContext)
  const { stores, replaceCheckout } = useShopify()

  const applyDiscountCode = async (discountCode, checkouts) => {
    const { client } = stores[checkouts.storeSubdomain]
    const segmentId = await getSegmentAnonymousId()

    try {
      const {
        data: {
          checkoutDiscountCodeApplyV2: {
            checkout: {
              id,
              webUrl,
              lineItems,
              customAttributes,
              discountApplications,
            },
          },
        },
      } = await applyCheckoutDiscountCode(client, {
        checkoutId: checkouts.id,
        discountCode: discountCode,
      })

      replaceCheckout(
        {
          ...checkouts,
          id,
          webUrl,
          lineItems,
          customAttributes,
          discountApplications,
        },
        segmentId,
      )
    } catch (error) {
      console.error(error)
    }
  }
  return applyDiscountCode
}

export default useApplyDiscountCode
